export default __webpack_public_path__ + "aaac7a7b95baaca975c278ed265032bc.png";